import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { Avatar, Box, IconButton } from '@mui/material'
import { GridRenderCellParams, GridRowId } from '@mui/x-data-grid-pro'
import { stringAvatar } from 'components/DataGrid/gridOperators'
import FlexTypography from 'components/ui/flex-typography'
import { FC } from 'react'
import { DensityStyleTypes, OrganizationTableItem } from 'types'

interface RenderOrgCellProps {
  params: GridRenderCellParams
  densityStyles: DensityStyleTypes
  handleRowClick: (row: OrganizationTableItem) => void
  toggleExpanded: (id: GridRowId) => void
}

const RenderOrganizationCell: FC<RenderOrgCellProps> = ({ params, densityStyles, handleRowClick, toggleExpanded }) => {
  const { rowNode, row: _row, value } = params
  const row = params.row
  const { PK, isParent } = row
  const _org_uuid = PK?.split('ORG_')?.[1]
  const isChild = !isParent
  const depth = rowNode?.depth ?? 0
  const indent = depth * 20

  // only parent rows get an expand button
  // cast away TS so we can see the internal children array
  const internalNode = rowNode as any
  const hasChildren = (internalNode.children?.length ?? 0) > 0
  const isGroup = isParent && hasChildren
  const isExpanded = Boolean(internalNode.childrenExpanded)

  const organization = params?.row ?? null
  const _orgName = organization?.name ?? ''
  //@ts-ignore
  if (params?.rowNode?.isAutoGenerated) return
  // if (params?.row?.rowId === '__SERVER_AGGREGATIONS_ROW__') return
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        height: '100%',
        pl: isChild ? `${indent}px` : densityStyles.padding,
        pt: densityStyles.padding,
        pb: densityStyles.padding,
        pr: densityStyles.padding,
        gap: densityStyles.gap,
        width: '100%',
        cursor: 'pointer',
      }}
      onClick={() => handleRowClick(row)}
    >
      <>
        {isGroup && (
          <IconButton
            size="small"
            disabled={!hasChildren} // gray out if no children
            onClick={e => {
              e.stopPropagation()
              toggleExpanded(params.id)
            }}
            sx={{ color: hasChildren ? 'inherit' : 'text.disabled' }}
          >
            {isExpanded ? (
              <ExpandMoreIcon />
            ) : (
              <ChevronRightIcon sx={{ color: hasChildren ? 'text.primary' : 'text.disabled' }} />
            )}
          </IconButton>
        )}

        {/* {isChild && (
          <FiberManualRecordIcon
            sx={{
              fontSize: 8,
              color: 'text.disabled',
              ml: 1,
              mr: 1,
            }}
          />
        )} */}

        {/* avatar only on parent rows */}
        {isParent &&
          (organization?.photoUrl ? (
            <Avatar
              src={organization.photoUrl}
              sx={{
                width: densityStyles.avatarSize,
                height: densityStyles.avatarSize,
                objectFit: 'cover',
                objectPosition: 'center',
                ml: 1,
              }}
              alt={value}
            />
          ) : (
            <Avatar
              {...stringAvatar(value, densityStyles)}
              sx={{
                backgroundColor: 'rgb(114, 229, 218)',
                width: densityStyles.avatarSize,
                height: densityStyles.avatarSize,
                ml: 1,
              }}
              alt={value}
            />
          ))}

        {/* finally, the row label */}
        <FlexTypography
          sx={{
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            fontSize: densityStyles.fontSize,
            fontWeight: isParent ? 600 : 400,
            ml: isParent ? 1 : 0,
            color: row?.isOrgTask ? 'text.highlight' : 'text.primary',
          }}
        >
          {value}
        </FlexTypography>
      </>
    </Box>
  )
}

export default RenderOrganizationCell
